<app-nvabar></app-nvabar>
<router-outlet />

<!-- ── Global Loading Overlay ── -->
@if (loading.isLoading()) {
  <div class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-[2px]">
    <div class="flex flex-col items-center gap-4 rounded-2xl bg-white px-8 py-7 shadow-2xl">
      <!-- Spinner -->
      <div class="relative w-14 h-14">
        <div class="absolute inset-0 rounded-full border-4 border-slate-100"></div>
        <div class="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 animate-spin"></div>
        <div class="absolute inset-0 flex items-center justify-center">
          <span class="material-symbols-outlined text-blue-600" style="font-size:1.25rem">hotel</span>
        </div>
      </div>
      <p class="text-sm font-semibold text-slate-700">{{ 'กำลังโหลด...' | translate : 'app' }}</p>
    </div>
  </div>
}
